import { useEffect } from 'react';
import { DirectoryEntities } from '@nice-devone/common-sdk';
import { useNicService } from 'stores/nic/useNicService';
/**
 * Loads the agent/skill/team directories the transfer and conference flows read
 * from, but only for the tab that owns WebRTC and only while the window is open
 * — the SDK keeps a subscription open per request, so non-owner tabs would
 * duplicate the traffic for data they never render.
 */
export var useNicDirectoryData = function (_a) {
    var isWindowOpen = _a.isWindowOpen, isSessionActive = _a.isSessionActive, isWebRtcOwner = _a.isWebRtcOwner;
    var loadDirectoryData = useNicService().loadDirectoryData;
    useEffect(function () {
        if (isWindowOpen && isSessionActive && isWebRtcOwner) {
            var cleanup_1 = loadDirectoryData({
                entity: [
                    DirectoryEntities.AGENT_LIST,
                    DirectoryEntities.SKILL_LIST,
                    DirectoryEntities.TEAM_LIST
                ]
            });
            return function () {
                if (cleanup_1) {
                    cleanup_1();
                }
            };
        }
    }, [isWindowOpen, isSessionActive, isWebRtcOwner, loadDirectoryData]);
};
